@if (data(); as data) {
  @if (data.title) {
    <h2 class="title">{{ data.title }}</h2>
  }

  @if (gridItems(); as items) {
    <div class="grid">
      @for (item of items; track item) {
        @if (item) {
          <ng-template
            [cxComponentWrapper]="{
              flexType: item.typeCode,
              typeCode: item.typeCode,
              uid: item.uid,
            }"
          ></ng-template>
        }
      }
    </div>
  }
}
